(function (skyward, $, undefined)
{
    skyward.entrywithdrawalspecialprogram = skyward.entrywithdrawalspecialprogram || {};

    var init = function (selector)
    {
        "use strict";
        
        var SpecialProgramsContainer = $(selector).find("#EnrollmentSpecialProgramsEndEnrollContainer");
        if (SpecialProgramsContainer.length > 0)
        {
            //Individual Special Program Wrapper functions
            $(function ()
            {
                $("input, textarea").on('errorChange', function ()
                {
                    if ($(this).hasClass('error-control'))
                    {
                        if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').toggleClass('error-control');
                        }
                    }
                    else
                    {
                        if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                        {
                            if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                            {
                                $(this).closest('.specialProgramContainer').removeClass('error-control');
                            }
                        }
                    }
                });
            });

            $(".specialProgramContainer").each(function () {
                var programContainer = { container: this }
                registerContainerParts(programContainer)
            });
        }
        else
        {
            return;
        }
    };

    var registerContainerParts = function (specialProgram)
    {
        specialProgram.fieldsContainer = $(specialProgram.container).find('fieldset');
        specialProgram.expandButton = $(specialProgram.container).find('#expandButton');
        specialProgram.collapseButton = $(specialProgram.container).find('#collapseButton');

        specialProgram.expandButton.click(function ()
        {
            skyward.entrywithdrawalspecialprogram.expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
        specialProgram.collapseButton.click(function ()
        {
            skyward.entrywithdrawalspecialprogram.expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
    };

    skyward.entrywithdrawalspecialprogram.expandCollapse = function (specialProgramsContainer, expandButton, collapseButton)
    {
        var wrapper = specialProgramsContainer;
        var isHidden = specialProgramsContainer.hasClass('collapsed');

        if (isHidden)
        {
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);